import React, { useState } from "react";
import { Badge } from "react-bootstrap";
import { toast } from "react-toastify";

const EmailChipsInput = ({
  label,
  onEmailsChange,
  setFieldValue,
  keyData,
  value,
  chipValue = [],
  placeholder,
  emailInput = true,
}) => {
  const [emails, setEmails] = useState(chipValue);

  const handleKeyDown = (event) => {
    if (event.key === "," || event.key === "Enter") {
      event.preventDefault();
      addEmail(value.trim());
    }
  };

  const addEmail = (input) => {
    if (!input) return; // Exit early if input is empty

    const emailList = input.split(",").map((email) => email.trim()); // Split input by commas and trim spaces
    const newValidEmails = [];
    const existingEmails = [];

    emailList.forEach((email) => {
      if (validateEmail(email)) {
        if (!emails.includes(email)) {
          newValidEmails.push(email);
        } else {
          existingEmails.push(email); // Track duplicates
        }
      } else {
        toast.error(`Invalid Email: ${email}`); // Show error for invalid email
      }
    });

    if (newValidEmails.length > 0) {
      const updatedEmails = [...emails, ...newValidEmails];
      setEmails(updatedEmails);
      onEmailsChange(updatedEmails);
    }

    // if (existingEmails.length > 0) {
    //   toast.error(`Duplicate Email(s): ${existingEmails.join(", ")}`);
    // }

    setFieldValue(keyData, "");
  };

  const handleDeleteEmail = (index) => {
    const updatedEmails = emails.filter((_, i) => i !== index);
    setEmails(updatedEmails);
    onEmailsChange(updatedEmails);
  };

  const validateEmail = (email) => {
    if (emailInput) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    } else {
      return true;
    }
  };

  const handleBlur = () => {
    addEmail(value.trim());
  };

  return (
    <div>
      {label && <label>{label}</label>}
      <div className="chip-container">
        {emails.map((email, index) => (
          <Badge
            key={index}
            pill
            bg="primary"
            className="me-1 badge"
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "6px 10px",
            }}
            title={email}
          >
            <div className="badge-text">{email}</div>
            <span
              style={{
                marginLeft: "8px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={() => handleDeleteEmail(index)}
            >
              &#10005;
            </span>
          </Badge>
        ))}
        <input
          type="text"
          className="chip-input form-control"
          value={value}
          onChange={(e) => setFieldValue(keyData, e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
};

export default EmailChipsInput;
